import React, { Fragment } from "react";
import styles from "./Header.module.css";
import logo from './virus.png';
import { Link, withRouter } from "react-router-dom";

const style = { textTransform:'capitalize',textDecoration: 'none', fontSize: '15px', fontWeight: 'bold' };
const Header = (props) => {
  return (
    <Fragment>
      <div className={styles.header}>
        <span><img src={logo} className={styles.logo} alt="img-logo" /></span>
        <span className={styles.title}>ShareInfo</span>
        <span className="space-filer" />
        {/* <span className={styles.menu}><i className="fas fa-bars"></i></span> */}
        <span className={styles.links}>
          <Link  style={props.location.pathname === '/'? { ...style,color: 'green'} : {...style,color:'black'}} to="/">HOME</Link></span>
        <span className={styles.links} >
          <Link style={props.location.pathname === '/news'? { ...style,color: 'green'} : {...style,color:'black'}}  to="/news">NEWS</Link></span>
          <span className={styles.links} >
          <Link style={props.location.pathname === '/heatMap'? { ...style,color: 'green'} : {...style,color:'black'}}  to="/heatMap">HEAT MAP</Link></span>
      </div>
    </Fragment>
  );
};

export default withRouter( Header);
